export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/referral_program_perseus/header.65b4f87.png";